module.exports = __webpack_public_path__ + "static/media/welcomeSlogan.151d7090.svg";